import { GET_TENANT_PROFILE, RESET_TENANT_PROFILE } from "../../actionTypes/actionsTypes";
import { AppAction, AppNoApiAction, BaseAsyncReducerState } from "../../types";

export interface TenantProfileState extends BaseAsyncReducerState {
    tenantProfile?: Record<string, unknown>;
}

const initialState: TenantProfileState  = {
    loading: false,
    error: false
}

function tenantProfileReducer(state = initialState, action: AppAction | AppNoApiAction) {
    const { payload } = action;

    switch (action.type) {
        case GET_TENANT_PROFILE.PENDING:
            return {
                ...state,
                loading: true,
                error: false
            }
        case GET_TENANT_PROFILE.SUCCESS:
            return {
                ...state,
                tenantProfile: payload,
                loading: false,
                error: false
            }
        case GET_TENANT_PROFILE.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case RESET_TENANT_PROFILE:
            return {
                ...state,
                reports: null
            }
        default:
            return state
    }
}

export default tenantProfileReducer;
